import loadable from '@loadable/component';
import loadableModule from '../../components/loadable-module';

const GreatPlacesToStayModule = loadableModule({
    LoadableComponent: loadable(() =>
        import(
            /* webpackChunkName: "great-places-to-stay" */
            './'
        )
    ),
    componentName: 'GreatPlacesToStay',
    placeholder: {
        cardType: 'CardType2',
        placeholderType: 'TitledBlockCarousel',
        size: 'md',
    },
});
export default GreatPlacesToStayModule;
